import { useContext } from "react"

import { LayoutContext } from "@/App/layoutContextDef"

export const useLayoutContext = () => useContext(LayoutContext)
